export const scheduleProperties = {
  name: {
    maxLength: 150,
  },
  description: {
    maxLength: 801,
  },
};
